import React, {useState} from 'react'

import noImage from 'assets/images/dashboard/noImage.png'
import {Box, Button} from '@mui/material'
import Lightbox from "yet-another-react-lightbox";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import ZoomIcon from 'assets/icons/zoom.svg'
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import ImagePagination from "react-image-pagination";


const ContentFrame = ({children, sx, frameSx, controls}) => {
    return <Box
        sx={{
            height: '10vh', // Changed to full viewport height
            overflow: 'hidden',
            ...frameSx,
            '& img, & video': {
                borderRadius: '10px',
                height: '100%',
                width: '100%',
                ...sx,
                objectFit: 'cover', 
            }
            // '& img , & video' : {
            //     borderRadius: '10px',
            //     height: '100%',
            //     width: {
            //         xs: '100%',
            //         lg: '100%'
            //     },
            //     ...sx
            // }
        }}>{children}

        </Box>
}
export const RenderContent = ({fileOrStream, sx, frameSx, type}) => {

    const [isOpen, setIsOpen] = useState(false);
    const [image, setImage] = useState();
    const zoomRef = React.useRef(null);
    const handleLightBox = (img) => {
        setImage(img)
        setIsOpen(true)
    }

    const props = {
        sx,
        frameSx
    }
    if (typeof fileOrStream == 'string') {

        const File = fileOrStream.split('/')
        const FileName = File.pop();

        if (FileName.includes('.mp4')) {
            return <ContentFrame {...props}>
                <video controls="controls">
                    <source src={fileOrStream}/>
                </video>
            </ContentFrame>
        } else {
            return <ContentFrame {...props}>

            {type != 'edit' && (
                <Box
                    sx={{
                        display: 'flex',
                        height: '100%',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>

                    <img src={fileOrStream}/>
                    <Button
                        sx={{
                            height:60,
                            width:10,
                            position: 'absolute',
                            bottom: 0,
                            right: 0,
                            margin: '3px',
                    
                        }}  
                        onClick={() => handleLightBox(fileOrStream)}>
                        <img style={{width:35}} src={ZoomIcon}/>
                    </Button>
                    <Lightbox
                        open={isOpen}
                        plugins={[Fullscreen, zoom]}
                        zoom={{
                            ref: zoomRef
                        }}
                        close={() => setIsOpen(false)}
                        slides={[{
                                src: fileOrStream
                            }
                        ]}/>
                </Box>
            )}
               
            </ContentFrame>
        }
    }

    if (
        fileOrStream?.type.includes('image')
    ) 

        return <ContentFrame {...props}>
             <img src={URL.createObjectURL(fileOrStream)}/>
        </ContentFrame>
    if (
        fileOrStream?.type.includes('video')
    ) 
        return <ContentFrame {...props}>
            <video controls="controls">
                <source src={URL.createObjectURL(fileOrStream) + '#t=0.1'}/>
            </video>
        </ContentFrame>

    return <ContentFrame><img src={noImage}/></ContentFrame>
}
